import NavItem from './NavItem';
import PropTypes from 'prop-types';
import Logo from 'src/components/Logo';
import React, { useEffect, useState } from 'react';
import Scrollbars from 'src/components/Scrollbars';
import { Link as RouterLink, useLocation, matchPath } from 'react-router-dom';
import { makeStyles } from '@material-ui/core/styles';
import {
  Box,
  Link,
  List,
  Avatar,
  Drawer,
  Hidden,
  Typography
} from '@material-ui/core';
import { useSelector } from 'react-redux';
import { isEmpty, trimChars } from 'src/utils';
import StatisticsComponents from '../../../views/Statistics';
import StartModal from '../../../views/DashboardAppView/StartModal';

const DRAWER_WIDTH = 280;

const useStyles = makeStyles((theme) => {
  const isLight = theme.palette.mode === 'light';

  return {
    drawer: {
      [theme.breakpoints.up('lg')]: {
        flexShrink: 0,
        width: DRAWER_WIDTH
      }
    },
    drawerPaper: {
      width: DRAWER_WIDTH,
      background: theme.palette.background.default
    },
    subHeader: {
      ...theme.typography.overline,
      marginTop: theme.spacing(3),
      marginBottom: theme.spacing(2),
      paddingLeft: theme.spacing(5),
      color: theme.palette.text.primary
    },
    account: {
      display: 'flex',
      alignItems: 'center',
      padding: theme.spacing(2, 2.5),
      margin: 20,
      borderRadius: theme.shape.borderRadiusSm,
      background: theme.palette.grey[isLight ? 200 : 800]
    }
  };
});

// ----------------------------------------------------------------------

function reduceChild({ array, item, pathname, level }) {
  const key = item.href + level;
  if (item.items) {
    const match = matchPath(pathname, {
      path: item.href,
      exact: false
    });

    array = [
      ...array,
      <NavItem
        key={key}
        level={level}
        icon={item.icon}
        info={item.info}
        href={item.href}
        title={item.title}
        open={Boolean(match)}
      >
        {renderNavItems({
          pathname,
          level: level + 1,
          items: item.items
        })}
      </NavItem>
    ];
  } else {
    array = [
      ...array,
      <NavItem
        key={key}
        level={level}
        href={item.href}
        icon={item.icon}
        info={item.info}
        title={item.title}
      />
    ];
  }
  return array;
}

function renderNavItems({ items, pathname, level = 0 }) {
  return (
    <List disablePadding>
      {items.reduce(
        (array, item) => reduceChild({ array, item, pathname, level }),
        []
      )}
    </List>
  );
}

NavBar.propTypes = {
  onCloseNav: PropTypes.func,
  isOpenNav: PropTypes.bool
};

function NavBar({ isOpenNav, onCloseNav }) {
  const allConfigs = useSelector((state) => state.globalState.allConfigs);
  const clientInfo = useSelector((state) => state.globalState.clientInfo);
  const clientId = useSelector((state) => state.globalState.clientID);
  const classes = useStyles();
  const [menuItem, setMenuItems] = useState([]);
  const { pathname } = useLocation();

  useEffect(() => {
    if (isOpenNav && onCloseNav) {
      onCloseNav();
    }
    var withoutSlashPathname = trimChars(pathname, '/');
    var breakPathName = withoutSlashPathname.split('/');
    var menus = [];
    if (pathname !== '/profile') {
      if (breakPathName.length > 1) {
        var viewsMenu = {
          subheader: 'תצוגות',
          items: [
            {
              title: 'תצוגות',
              // href: `/app/${breakPathName[1] || ''}`,
              href: `/crm/${breakPathName[1] || ''}`,
              items: []
            }
          ]
        };
        var viewItems = [];
        if (
          !isEmpty(allConfigs['UI Config'] && allConfigs['UI Config'].views)
        ) {
          Object.keys(allConfigs['UI Config'].views).map((keyName, i) =>
            viewItems.push({
              title: allConfigs['UI Config'].views[keyName],
              // href: `/app/${breakPathName[1]}/${keyName}`
              href: `/crm/${breakPathName[1]}/${keyName}`
            })
          );
        }
        viewsMenu.items[0].items = viewItems;
        menus.push(viewsMenu);
        setMenuItems(menus);
      } else {
        setMenuItems(menus);
      }
      if (breakPathName.length === 1) {
        setMenuItems([]);
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pathname, allConfigs]);

  const renderContent = (
    <Scrollbars>
      <Hidden lgDown>
        <Box sx={{ px: 2.5, py: 3 }}>
          {clientId ? (
            <Link
              underline="none"
              component={RouterLink}
              // to={`/app/${clientId}/${
              //   allConfigs['UI Config'].lead_card_info.default_view ||
              //   'UI_DefaultView'
              // }`}
              to={`/crm/${clientId}/${
                allConfigs['UI Config'].lead_card_info.default_view ||
                'UI_DefaultView'
              }`}
            >
              <Logo />
            </Link>
          ) : (
            <Logo />
          )}
        </Box>
      </Hidden>

      <div className={classes.account}>
        <Avatar
          alt="My Avatar"
          style={{ backgroundColor: '#a852ff', color: '#fff' }}
        >
          {clientInfo['First Name']
            ? clientInfo['First Name'].slice(0, 2)
            : 'DT'}
        </Avatar>
        <Box sx={{ ml: 2 }}>
          <Typography variant="subtitle2" sx={{ color: 'text.primary' }}>
            {clientInfo['Name'] || ''}
          </Typography>
        </Box>
      </div>

      {menuItem.length > 0 ? (
        <>
          {menuItem.map((list) => (
            <List key={list.subheader}>
              {renderNavItems({
                items: list.items,
                pathname: pathname
              })}
            </List>
          ))}
          {clientId ? (
            <>
              <StatisticsComponents clientId={clientId} title="Desktop" />
              <StartModal show="nav" />
            </>
          ) : null}
          <Box style={{ paddingRight: 40, paddingTop: 20, paddingBottom: 20 }}>
            <small style={{ color: '#8794a0', fontSize: 10 }}>
              Version 1.1.0
            </small>
          </Box>
        </>
      ) : null}
    </Scrollbars>
  );

  return (
    <nav className={classes.drawer}>
      <Hidden lgUp>
        <Drawer
          anchor="right"
          open={isOpenNav}
          variant="temporary"
          onClose={onCloseNav}
          classes={{ paper: classes.drawerPaper }}
        >
          {renderContent}
        </Drawer>
      </Hidden>
      <Hidden lgDown>
        <Drawer
          open
          anchor="right"
          variant="persistent"
          classes={{ paper: classes.drawerPaper }}
        >
          {renderContent}
        </Drawer>
      </Hidden>
    </nav>
  );
}

export default NavBar;
